
<div class="outer-div">
  <div class="label-bar">
     <label i18n="@@spmsUserReg" class="textColour" style="font-size: 18px;
    font-weight: 500;">Formula Builder</label>
     <span class="example-spacer"></span>
             <app-common-button
         
          title="Refresh"
		  icon="fas fa-sync-alt"
         [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="loadFormulas()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
          <app-common-button
        icon="fas fa-download"
  
           title="Download "
          [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onDownload()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
       <app-common-button
        label="Create"
          title="Create"
          icon="fas fa-plus-circle"
          [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onCreate()"
          style="margin-right:1%"
          >
      </app-common-button>
  </div>
<!-- <div class="summary-row">
  <div class="summary-card">
    <span class="label">Total Products</span>
    <span class="value">330</span>
  </div>

  <div class="summary-card">
    <span class="label">Total Alert Rules</span>
    <span class="value">250</span>
  </div>

  <div class="summary-card">
    <span class="label">Active Alert Rules</span>
    <span class="value">250</span>
  </div>

  <div class="summary-card">
    <span class="label">Mapped Products </span>
    <span class="value">350</span>
  </div>
  <div class="summary-card">
    <span class="label">UnMapped Products</span>
    <span class="value">350</span>
  </div>
  <div class="summary-card">
    <span class="label">Default</span>
    <span class="value">350</span>
  </div>

  </div> -->
  <div style="width: 100%;margin-bottom: 5%;">
    <div style="margin-top: 1.5%;display: flex;gap: 1%;">
       <!-- <div class="search-box">
      <i class="pi pi-search"></i>
      <input
        type="text"
        placeholder="Search by Formula Name , description..."
        (input)="onSearch($event)"
        #searchInput
      />
      <button 
        *ngIf="searchInput.value" 
        class="clear-search"
        (click)="clearSearch(searchInput)"
      >
        ×
      </button>
    </div> -->
    <p-select
      [options]="formulaOptions"
      optionLabel="formulaName"
      optionValue="formulaName"
      placeholder="Formula"
      [filter]="true"
       panelStyleClass="custom-pselect-panel"
         appendTo="body"
      [showClear]="true"
       class="filter-dd"
      (onChange)="onFilterChange('formula', $event.value)">
    </p-select>

    <p-select
      [options]="formulaType"
      optionLabel="formulaType"
      optionValue="formulaType"
      placeholder="Formula type"
       panelStyleClass="custom-pselect-panel"
         appendTo="body"
      [filter]="true"
      [showClear]="true"
       class="filter-dd"
      (onChange)="onFilterChange('type', $event.value)">
    </p-select>



<span class="example-spacer"></span>
    </div>

    <ag-grid-angular
      style="margin-top: 2%;height: 55vh;"
      class="ag-theme-balham"
      [rowData]="filteredData"
      [components]="components"
      [rowHeight]="35"
      [headerHeight]="35"
      [enableBrowserTooltips]="true"
      [floatingFiltersHeight]="45"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowSelection]="'multiple'"
      [suppressRowClickSelection]="true"
      [animateRows]="true"
      [paginationPageSize]="10"
      [pagination]="true"
      (gridReady)="onGridReady($event)"
     >
    </ag-grid-angular>


  </div>
</div>
